import BaseGameFactory from "../../core/src/factories/BaseGameFactory";
import BaseSettings from "../../core/src/ui/BaseSettings";
import UIDesktopView from "../base/ui/UIDesktop";
import BaseUI from "../../core/src/ui/BaseUI";
import AutoplayPopup from "../base/ui/AutoplayPopup";


import InfoBar from '../base/ui/InfoBar';
import PageSettings from '../../core/src/ui/settings/PageSettings';

import VendorSettings from "../../../vendor_core/src/base/ui/VendorSettings";

export class GameFactory extends BaseGameFactory {
    protected getSettings(): BaseSettings {
        return new VendorSettings();
    }

    protected getAutoplayPage(): BaseUI {
        return new AutoplayPopup();
    }

    protected getUIView(): BaseUI {
        return new UIDesktopView();
    }

    protected getInfoBar(): BaseUI {
        return new InfoBar();
    }


}

export default GameFactory;
